import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./design-tokens.css";
import "./arc/arc-bridge.css";
import App from "./App";
import {
  ToastStackProvider,
  ToastStack,
} from "./arc/components/toast-stack/toast-stack";
import reportWebVitals from "./reportWebVitals";

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastStackProvider>
      <App />
      <ToastStack />
    </ToastStackProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
